import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTabs } from '@hooks/common/useTabs';
import styled from 'styled-components';

import { Divider, Tab, Tabs } from '@mui/material';

import { Indicators } from '../enums';

const config = [
  { label: 'common.titles.profile', value: Indicators.PROFILE },
  { label: 'common.titles.billing', value: Indicators.BILLING },
  { label: 'common.titles.transactions', value: Indicators.TRANSACTIONS },
];

// Styled tabs with theme-v2 dark theme support
const StyledSettingsTabs = styled(Tabs)`
  width: 100%;
  min-height: 42px;

  .MuiTabs-indicator {
    background-color: var(--sk-cyan-500);
    height: 3px;
    border-radius: 2px 2px 0 0;
  }

  .MuiTab-root {
    font-family: var(--sk-font-body);
    font-size: var(--sk-text-sm);
    font-weight: 500;
    color: var(--sk-text-secondary);
    text-transform: none;
    min-height: 42px;
    padding: var(--sk-space-2) var(--sk-space-4);
    transition: color 0.2s ease;

    &:hover {
      color: var(--sk-text-primary);
    }

    &.Mui-selected {
      color: var(--sk-cyan-400);
      font-weight: 600;
    }
  }
`;

const StyledDivider = styled(Divider)`
  margin-top: -1px;
  border-color: var(--sk-surface-border);
`;

const ToggleTabs: FC = () => {
  const { t } = useTranslation();
  const { tab, handleChange } = useTabs(Indicators.PROFILE, Indicators);

  return (
    <>
      <StyledSettingsTabs
        value={tab}
        onChange={handleChange}
        aria-label="settings tabs"
      >
        {config.map(v => (
          <Tab value={v.value} label={t(v.label)} key={v.value} />
        ))}
      </StyledSettingsTabs>
      <StyledDivider />
    </>
  );
};

export default memo(ToggleTabs);
